import axios from "axios";
import { getSessionId } from "../../../utils/tokenHandlers";

export const uploadSupportingDocument = async (
  docName: string | Blob,
  selectedFile: string | Blob
) => {
  const sessionid = getSessionId();
  const formData = new FormData();

  if (docName) {
    formData.append("name", docName);
  }

  formData.append("type", "binary");
  formData.append("datas", selectedFile);

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}api/upload/image`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${sessionid}`,
        },
      }
    );

    const { data } = response;

    if (data) {
      const { message, data: responseData } = data;
      if (responseData) {
        const { attachement } = responseData;
        localStorage.setItem("attachmentids", attachement);
      }
      if (message === "Success") {
        // Success logic (if any)
      }
    }

    return response.data;
  } catch (error) {
    throw error;
  }
};
